import * as React from 'react';
import {observer} from 'mobx-react';
import {useNavigate} from 'react-router-dom';
import {useApplication} from '../../../ApplicationProvider';
import {useNavigatorFeature} from '../../../useFeature';
import LayoutContentWrapper from '../../../components/layout/LayoutContentWrapper';
import LayoutContentToolbar from '../../../components/layout/LayoutContentToolbar';
import FilledButton from '../../../components/buttons/FilledButton';
import Table from '../../../components/table/Table';
import AddIcon from '@mui/icons-material/Add';
import ListAllowancesFeature from './ListAllowancesFeature';
import AllowancesCreditNotesDownload from './AllowancesCreditNotesDownload';
import {CREATE_ALLOWANCE_PATH} from '../../../routes';

function ListAllowancesScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListAllowancesFeature(application, navigator), navigator);
    const isFeatureReady = feature && feature.loaded;
    const canCreateAllowances = application.canAccessPath(CREATE_ALLOWANCE_PATH);

    const content = () => (
        <div>
            <LayoutContentToolbar title="Bonificaciones">
                {application.hasAllowancesCreditNotesPermission() &&
                    <AllowancesCreditNotesDownload monthField={feature.creditNotesMonthField()}
                                                   monthOptions={feature.creditNotesMonthOptions()}
                                                   isDownloading={feature.downloading}
                                                   onDownload={() => feature.downloadCreditNotes()}/>}
                {canCreateAllowances &&
                    <FilledButton onClick={() => navigator(CREATE_ALLOWANCE_PATH)} style={{whiteSpace: 'nowrap'}}>
                        <AddIcon fontSize="small"/>
                        Crear nueva
                    </FilledButton>}
            </LayoutContentToolbar>
            <Table columns={feature.columns()} rows={feature.presentedAllowances()}/>
        </div>
    );

    return <LayoutContentWrapper isLoading={!isFeatureReady} renderContent={() => content()}/>;
}

export default observer(ListAllowancesScreen);
